export default {
  nav: {
    home: '首頁',
    technology: '技術中心',
    products: '產品中心',
    quality: '品質保證',
    sales: '銷售網絡',
    customers: '客戶案例',
    about: '關於我們',
    contact: '聯繫我們'
  },
  home: {
    hero: {
      title: '尋找機械零件供應商？',
      subtitle: '深耕自動化行業十餘年，立足中國，面向全球。',
      btnDetails: '了解詳情',
      btnAbout: '關於我們'
    },
    products: {
      actuators: '氣動執行器',
      controllers: '氣動控制器',
      accessories: '氣動配件',
      emotion: 'E-Motion系列產品',
      machineParts: '機器零件',
      solutions: '定制化解決方案'
    },
    contact: {
      title: '聯繫我們',
      getStarted: '立即聯繫'
    }
  },
  products: {
    title: '產品中心',
    subtitle: '高品質產品，滿足多樣化需求',
    categories: {
      all: '全部產品',
      actuators: '氣動執行器',
      accessories: '氣動配件',
      controllers: '氣動控制器',
      parts: '機器零件'
    },
    items: {
      actuator: {
        name: '氣動執行器'
      },
      controller: {
        name: '氣動控制器'
      },
      accessories: {
        name: '氣動配件'
      },
      solutions: {
        name: '定制化解決方案'
      },
      emotion: {
        name: 'E-Motion系列產品'
      },
      machineParts: {
        name: '機器零件'
      }
    }
  },
  contact: {
    title: '聯繫方式',
    breadcrumb: {
      industrialParts: 'Gyre工業機械零件',
      actuators: '氣動執行器',
      controllers: '氣動控制器',
      solutions: '定制化解決方案',
      current: '聯繫方式'
    },
    heading: '聯繫我們',
    email: 'hemu@gyansol.com',
    whatsapp: '+86 13357553736',
    tel: '電話：',
    phone: '+8619290808990',
    promise: '我們承諾在每個工作日提供高效的響應服務。'
  },
  footer: {
    description: '領先的氣動元件品牌',
    links: {
      products: '產品中心',
      solutions: '解決方案',
      about: '關於我們'
    },
    copyright: '© 2025 GYRE CMS. 版權所有.'
  },
  common: {
    loading: '載入中...',
    noData: '暫無資料',
    error: '操作失敗',
    retry: '重試',
    save: '儲存',
    cancel: '取消',
    confirm: '確認'
  },
  notFound: {
    title: '404',
    subtitle: '頁面未找到',
    description: '您訪問的頁面不存在。',
    backHome: '返回首頁'
  },
  technology: {
    hero: {
      title: '技術創新',
      subtitle: '引領行業技術發展，提供卓越解決方案'
    },
    items: {
      smartManufacturing: {
        title: '智能製造',
        description: '採用先進的智能製造技術，提高生產效率和產品質量，實現生產過程的數字化和自動化。'
      },
      precisionControl: {
        title: '精密控制',
        description: '高精度控制系統確保產品的一致性和可靠性，滿足最嚴格的質量標準要求。'
      },
      energySaving: {
        title: '節能環保',
        description: '綠色製造技術，降低能耗和排放，實現可持續發展目標。'
      },
      digitalTransformation: {
        title: '數字化轉型',
        description: '全面的數字化解決方案，提升企業運營效率和市場競爭力。'
      }
    }
  },
  about: {
    hero: {
      title: '關於我們'
    },
    breadcrumb: {
      industrialParts: 'Gyre工業機械零件',
      actuators: '氣動執行器',
      controllers: '氣動控制器',
      solutions: '定制化解決方案',
      current: '關於我們'
    },
    intro: {
      text: '我們是一家專注於氣動、流體、電驅動和自動化設計的系統集成商，為非標自動化、半導體和醫療器械等高端行業提供定制化工程解決方案。公司總部位於昆山和寧波，兩個精密製造基地專門生產和定制產品——低摩擦氣缸、精密氣體調節器、醫療級配件和管道、緊湊型歧管閥和定制氣動櫃。'
    },
    welcome: {
      title: '歡迎',
      contact: '如何聯繫我們？',
      email: 'hemu@gyansol.com',
      tel: '電話：',
      phone: '+8619290808990',
      promise: '我們承諾在每個工作日提供高效的響應服務。'
    }
  }
}
